import api from "./api";

const cacheService = {
  // GET /admin/clear-cache - flush the Redis cache
  clearCache: () => api.get('/admin/clear-cache'),

  // GET /admin/redis-keys?pattern=* - list Redis cache keys (optional glob pattern)
  getRedisKeys: (pattern) =>
    api.get('/admin/redis-keys', { params: pattern ? { pattern } : {} }),
};

export default cacheService;
